// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3WW_L","col":"styles_col__1H1Zt"};